'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _wavfichacertaFichacertaSharedStyles = require('@bit/wavfichacerta.fichacerta.shared-styles.buttons');
var _styledComponents = require('styled-components');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var handleScaleSize = function handleScaleSize(size) {
  if (size === 'md') {
    return _wavfichacertaFichacertaSharedStyles.RegularScaleButton;
  }
  if (size === 'lg') {
    return _wavfichacertaFichacertaSharedStyles.BigScaleButton;
  }
  return _wavfichacertaFichacertaSharedStyles.BaseScaleButton;
};
/**
 * this customProps are props for Components that will extend this component
 */
var ScaleButton = function ScaleButton(_ref) {
  var _ref$scaleSize = _ref.scaleSize,
    scaleSize = _ref$scaleSize === undefined ? 'lg' : _ref$scaleSize,
    onClick = _ref.onClick,
    theme = _ref.theme,
    children = _ref.children,
    disabled = _ref.disabled,
    customProps = _objectWithoutProperties(_ref, ['scaleSize', 'onClick', 'theme', 'children', 'disabled']);
  var Button = handleScaleSize(scaleSize);
  return _react2.default.createElement(Button, Object.assign({
    borderColor: 'transparent',
    background: 'transparent',
    onClick: onClick,
    disabled: disabled === undefined ? theme.disabled : disabled
  }, customProps), children);
};
exports.default = (0, _styledComponents.withTheme)(ScaleButton);